import { MSI_TYPE_SCALE, usesAppStyleGrammar } from './msiStyleTokens';

/**
 * Shared typography helpers for the uppercase label treatment used throughout
 * the UI (section headers, toolbar/chip labels, pill buttons).
 *
 * `uppercaseLabel` owns only the properties that are consistent everywhere —
 * the uppercase transform and the default bold weight. Letter-spacing is left
 * to each call site on purpose: how wide the tracking runs is a deliberate,
 * per-context choice, not a single global value.
 */

export function uppercaseLabel(overrides = {}) {
  return {
    textTransform: 'uppercase',
    fontWeight: 700,
    ...overrides,
  };
}

// The dominant section/table heading: muted, lightly tracked, small caps.
export const sectionTitleSx = uppercaseLabel({
  color: 'text.secondary',
  fontSize: (theme) => (
    usesAppStyleGrammar(theme) ? MSI_TYPE_SCALE.tableHeader.fontSize : '0.76rem'
  ),
  letterSpacing: (theme) => (usesAppStyleGrammar(theme) ? 0 : '0.08em'),
});
